import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { errMsg, useApi } from "@/lib/api";

export function DeclareDialog({ result, index, onClose, onDone }) {
  const offer = result?.offers?.[index];
  const api = useApi();
  const [form, setForm] = useState({
    shop: offer?.shop || "", product_name: result?.product?.name || "", order_number: "", amount: offer ? String(offer.price) : "",
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    setBusy(true);
    try {
      await api("post", "/declarations", { ...form, amount: parseFloat(String(form.amount).replace(",", ".")), search_id: result?.id || null });
      toast.success("Acquisto dichiarato! Riceverai i punti dopo la verifica.");
      onDone?.();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="declare-dialog" className="border-white/10 bg-[#12141C] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-white">Dichiara il tuo acquisto</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-400">
          {offer ? "Abbiamo aperto il negozio in una nuova scheda. " : ""}Dopo aver acquistato, inserisci il numero d'ordine e l'importo pagato: dopo la verifica riceverai <b className="text-amber-300">1 punto per ogni €</b> al netto IVA.
        </p>
        {[["shop", "Negozio"], ["product_name", "Prodotto"], ["order_number", "Numero ordine"], ["amount", "Importo pagato (€)"]].map(([k, l]) => (
          <div key={k}>
            <Label className="text-xs text-slate-400">{l}</Label>
            <Input data-testid={`declare-${k}`} value={form[k]} onChange={set(k)} className="mt-1 bg-[#1C1F2C]" />
          </div>
        ))}
        <button data-testid="declare-submit" disabled={busy} onClick={submit} className="flex h-11 items-center justify-center gap-2 rounded-xl bg-amber-500 font-semibold text-black hover:bg-amber-400 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Invia dichiarazione
        </button>
      </DialogContent>
    </Dialog>
  );
}
